import React, { lazy } from 'react';
import PageDurationIcon from '@/assets/images/menu/page-duration.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const pageDurationRoutes = (): IRouteConfig[] => [
  {
    path: '/page-duration',
    name: '页面性能',
    icon: <MenuIcon icon={PageDurationIcon} />,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
    ],
    sort: 84,
    component: lazy(() => import('@/presentation/pages/page-duration')),
  },
];

export default pageDurationRoutes;
